import queryString from "query-string";
import { HTMLAttributes } from "react";

import { removeKeysMatching } from "@utils/helpers";
import {
    GroupToPrefixMap,
    Route,
} from "@utils/search/routing/@types/route.types";
import { configurationToRoute } from "@utils/search/routing/configurationToUrl/configurationToRoute";
import { PREFIX_SEPARATOR } from "@utils/search/routing/routing.configuration";

import { SearchConfiguration } from "@redux/modules/value/search/search.types";

const createUrl = (route: Route) => {
    const { query, url } = queryString.parseUrl(location.href);
    const newParams = removeKeysMatching(query, key =>
        Object.values(GroupToPrefixMap).some(prefix =>
            key.startsWith(`${prefix}${PREFIX_SEPARATOR}`),
        ),
    );
    return (
        queryString
            .stringifyUrl({
                url,
                query: {
                    ...newParams,
                    ...route,
                },
            })
            .replaceAll("%20", "+")
            .replaceAll("%2B", "+")
    );
};

const getWindowTitleHeadElement = () =>
    document.head.querySelector(
        "[property$=title][content]",
    ) as HTMLAttributes<Element>;

const updateWindowTitleByConfiguration = (
    configuration?: SearchConfiguration,
) => {
    const query = configuration?.query;
    const titleElement = getWindowTitleHeadElement();
    const currentTitle = titleElement?.content ?? "";

    document.title = query ? `${query} | ${currentTitle}` : currentTitle;
};

const configurationToUrl = (
    configuration: SearchConfiguration,
    ignoreQuery: boolean,
): string => {
    const route = configurationToRoute(configuration, ignoreQuery);
    return createUrl(route);
};

export { configurationToUrl, updateWindowTitleByConfiguration };
